import { render } from "./ConfirmDeviceDeleteDialog.vue?vue&type=template&id=b63680a4"
import script from "./ConfirmDeviceDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmDeviceDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__